export const getWebsocketUrl = (path) => {
  const loc = window.location;
  return (loc.protocol === 'https:' ? 'wss:' : 'ws:') + '//' + loc.host + path;
}
